<template>
  <div class="msg-list">
    <van-cell
      :class="item.property.propertyStatus=== 3 || item.property.propertyStatus===0?'col_saled':''"
      class="msg-cell"
      @click="goUrl(item)"
    >
      <van-card :title="item.property.titleWithCulture">
        <!-- 图片部分 -->
        <div
          slot="thumb"
          class="col-card__thumb"
        >
          <span
            v-show="showCol"
            class="collection"
          >
            <!-- <div class="inco-xin"></div> -->
            <div class="col-icon">
              <img
                src="@/assets/soucang.png"
                style="width:20px; height:20px;"
                alt=""
              >
            </div>
          </span>
          <img
            v-lazy="pub.imgResize(item.property.imagePath)"
            class="img-hse"
            onerror="errorImg(this)"
          >

          <!--封盤 已租或已售 -->
          <p
            v-if="item.property.propertyStatus===3 || item.property.propertyStatus===0"
            class="saled"
          >
            {{ item.property.propertyStatusWithCulture }}
          </p>
          <p
            v-if="item.property.isVerifyLabel"
            class="reviewed"
          >
            {{ lang.verifyLabel }}
          </p>
          <!-- <div class="col-icon" v-show='item.collectionID'></div> -->
          <div
            v-show="item.collectionID"
            class="col-icon"
          >
            <svg
              class="icon"
              aria-hidden="true"
            >
              <use xlink:href="#icon-myFavourites1" />
            </svg>
          </div>
        </div>
        <!-- 置顶标签 -->
        <div
          v-if="item.property.topType"
          slot="tag"
          class="col-tag"
        >
          {{ item.property.topTypeWithCulture }}
        </div>
        <!-- 图片总数 -->
        <p
          v-if="item.property.imageNumber"
          slot="tag"
          class="imageNumber"
        >
          <span>{{ item.property.imageNumber }}</span>
        </p>
        <!-- 平面图-业主盘便签 -->
        <div
          slot="tag"
          :class="lang.type === 'en-us'?'col-plane-en':'col-plane'"
        >
          <p
            v-if="item.property.propertySource === 1"
            class="landlord"
          >
            <img
              class="icon"
              src="@/assets/yezhupan.svg"
            >
            <span>{{ lang.Landlord }}</span>
          </p>
          <p
            v-if="item.property.propertyLabel && item.property.propertyLabel[7]"
            class="plane"
          >
            <img
              class="icon"
              src="@/assets/pingmiantu.svg"
            >
            <span>{{ lang.plane }}</span>
          </p>
        </div>
        <!-- 分类标签 -->
        <div
          slot="tags"
          class="col-desc col-adress"
        >
          <!-- 屋苑+期数 -->
          <span class="card-tags">{{ item.property.estateNameWithCulture }} {{ item.property.phaseWithCulture }}</span>
          <!-- <span class="card-tags">{{item.property.gscopeNameWithCulture}} {{item.property.estateNameWithCulture}}</span>
          <span v-if="item.property.roomNumberWithCulture"> {{item.property.roomNumberWithCulture}}</span>
          <span> {{item.property.propertyCategoryWithCulture}}</span>
          <span v-for="(classitem,index) in item.property.subCategory" :key="index"> {{classitem}}</span>
          <span> {{rentLabel(item.property.rentLabel)}}</span> -->
        </div>
        <div
          slot="tags"
          class="col-desc"
        >
          <span v-if="item.property.roomNumberWithCulture">{{ item.property.roomNumberWithCulture }}&nbsp;</span>
          <span v-if="item.property.toiletNumberWithCulture">{{ item.property.toiletNumberWithCulture }}&nbsp;</span>
          <span v-if="item.property.unitFloorWithCulture">{{ item.property.toiletNumberWithCulture ? '|&nbsp;' + item.property.unitFloorWithCulture : item.property.unitFloorWithCulture }}</span>
        </div>
      </van-card>
      <!-- 价格部分 -->
      <div class="bh-price col-adress">
        <!--已補地價1未补，2已补，自由市場 綠表價/白居二  只展示固定类型楼盘-->
        <span
          v-if="item.property.saleForm && item.property.subCategory && item.property.subCategory[6] && item.property.rentalType == 1"
          class="saleform"
        >{{ item.property.saleForm == 1 ? lang.saleFormUnpaid : lang.saleFormPaid }} &nbsp;</span>
        <span class="card-price">
          {{ tool.getPrice(item.property.rentalType=== 1?item.property.salePrice:item.property.rentPrice,lang.type).replace(/[^0-9|$|.]/ig,'') }}
        </span><span
          v-if="tool.getPrice(item.property.rentalType=== 1?item.property.salePrice:item.property.rentPrice,lang.type).substring(tool.getPrice(item.property.rentalType=== 1?item.property.salePrice:item.property.rentPrice,lang.type).length-1).search(/[\d]/ig) === -1"
          :class="lang.type === 'en-us'?'card-price-small-en':'card-price-small'"
        >{{ tool.getPrice(item.property.rentalType=== 1?item.property.salePrice:item.property.rentPrice,lang.type).substring(tool.getPrice(item.property.rentalType=== 1?item.property.salePrice:item.property.rentPrice,lang.type).length-1) }}</span>
        <!-- <span class="card-price">
            {{tool.getPrice(item.property.rentalType=== 1?item.property.salePrice:item.property.rentPrice,lang.type)}}
          </span> -->
        <div class="col-price col-adress">
          <p class="practical">
            <span
              class="practical-top"
              style="font-size:11px;"
            >
              {{ tool.getAreaToText('',item.property.saleableArea,lang.type,item.property.isVerifyArea) }}
            </span>
            <span
              class="practical-bottom"
              style="font-size:11px;"
            >
              {{ tool.getAvgPriceToText('',item.property.saleableAvgPrice,lang.type) }}
            </span>
          </p>
          <p class="build">
            <span
              class="build-top"
              style="font-size:11px;"
            >
              {{ tool.getAreaToText(item.property.buildingArea,'',lang.type,item.property.isVerifyArea) }}
            </span>
            <span
              class="build-bottom"
              style="font-size:11px;"
            >
              {{ tool.getAvgPriceToText(item.property.buildingAvgPrice,'',lang.type) }}
            </span>
          </p>
        </div>
      </div>
      <!-- 标签 -->
      <div class="info-property-tags">
        <!-- 住宅 单栋式大厦 -->
        <template v-if="item.property.propertyCategoryWithCulture || item.property.subCategory">
          <span class="tags-span property col-adress">{{ item.property.propertyCategoryWithCulture }}
            <span
              v-for="(it, i) in item.property.subCategoryInfos"
              :key="i"
            > {{ it.name }}<span v-if="i !== item.property.subCategoryInfos.length - 1"> | </span></span>
          </span>
        </template>
        <template v-if="item.property.rentLabel">
          <!-- eslint-disable-next-line vue/no-use-v-if-with-v-for -->
          <span v-for="(it, i) in item.property.rentLabel" v-if="i == 3 || i == 4 || i == 5|| i == 8" :key="i" class="tags-span property col-adress">{{ it }}</span>
        </template>
        <template v-if="item.property.propertyTag">
          <span
            v-for="(it, i) in item.property.propertyTag"
            :key="i"
          >
            <span
              v-if="i < 5"
              class="tags-span col-adress"
            >{{ it.propertyTagName }}</span>
          </span>
        </template>
      </div>
      <div
        v-if="item.remark"
        class="bottom"
      >
        <!-- <p class="bh-company col-adress">{{getCompany(item.property.companyNameWithCulture,item.property.propertySource)}}</p> -->
        <p
          v-if="item.remark"
          class="col-remark col-adress"
        >
          {{ lang.collectionNotes }}：{{ item.remark }}
        </p>
        <p
          v-else
          class="col-remark col-adress"
        />
      </div>
    </van-cell>
  </div>
</template>

<script>
import pub from "../../common/public";
import lang from "../../common/language/history";
import tool from "../../common/js/tools.js"
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      }
    },
    type: {
      default: 'sale'
    },
    showCol: {
      default: false
    }
  },
  data () {
    return {
      tool,
      lang
    };
  },
  created () {
    this.lang.type = this.pub.getLang();
  },
  methods: {
    getCompany(company, property) {
      if (!company && property === 1) {
        return this.lang.landlord
      } else if (!company && property === 2) {
        return this.lang.agency
      } else if (company) {
        return company
      }
    },
    // 租标签
    rentLabel (val) {
      if (val) {
        if (val[3] && val[4]) {
          return `${this.lang.shortRent}${this.lang.sublet}`
        } else if (val[3]) {
          return this.lang.shortRent
        } else if (val[4]) {
          return this.lang.sublet
        }
      }
    },
    goUrl (item) {
      const type = this.lang.type === 'zh-hk' ? '' : this.lang.type + '/'
      let url = ''
      if (!this.pub.getCookie("cEVaUDFrZ1kd0RA")) {
        url = `?url=/my${this.$router.currentRoute.fullPath}`
      }
      if (item.property.rentalType === 1) {
        location.href = `/${type}buy-property-${item.property.propertyID}.html`;
      } else if (item.property.rentalType === 2) {
        location.href = `/${type}rent-property-${item.property.propertyID}.html`;
      }
      console.log("url",url)
    }
  }
};
</script>
<style scoped>
.img-hse {
  background-color: #fff;
}
.msg-list {
  box-sizing: border-box;
}
.van-cell {
  padding: 15px 15px 15px 0;
  border-bottom: 1px solid #ebedf0;
  box-sizing: border-box;
  position: relative;
  top: 0;
  left: 0;
}
.col_saled {
  opacity: 0.55;
}
.van-card__title {
  font-size: 17px;
  color: #333333;
  min-height: 45px;
  max-height: 46px;
  line-height: 23px;
  font-weight: bold;
}
.col-desc {
  font-size: 12px;
  line-height: 19px;
  color: #666666;
}
.col-adress {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
/* 图片部分 */
.van-card__thumb,
.col-card__thumb {
  width: 120px;
  height: 90px;
  /* overflow: hidden; */
  position: relative;
  top: 0;
  left: 0;
  text-align: center;
  background: url('//static.house730.com/m/images/house-bg.png');
  background-size: cover;
}
.van-card__thumb {
  margin-right: 16px;
}
.van-card__thumb img {
  width: 120px;
  height:90px;
  /* max-height: initial; */
}
.reviewed {
  font-size: 10px;
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 0 5px;
  height: 17px;
  background-color: #0054a6;
  line-height: 17px;
  color: #ffffff;
}
/* .col-icon {
  position: absolute;
  top: 2px;
  right: 4px;
  height: 18px;
  width: 18px;
  background-image: url('../assets/soucang.png');
  background-size: 18px 18px;
} */
.col-icon {
  position: absolute;
  /* top:-4px; */
  right: 4px;
  font-size:20px;
  z-index:5;
}
.saled {
  font-size: 17px;
  color: #ffffff;
  opacity: 0.55;
  background: #292630;
  width: 120px;
  height: 90px;
  line-height: 90px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
/* 分类标签部分 */
.van-card {
  padding: 0;
  background-color: #fff;
}
.van-ellipsis {
  overflow: inherit;
}
.van-card__content {
  text-align: left;
  height: auto;
  box-sizing:border-box;
  /* border-bottom:1px solid #EEEEEE; */
  padding:0 15px 5px 0;
}
.van-card__tag {
  top: 0;
}
.col-plane,
.col-plane-en{
  position: absolute;
  top: 90px;
}
.col-plane .icon,
.col-plane-en .icon {
  display: inline-block;
  width: 14px;
  height: 14px;
  margin-right: 2px;
}
.col-plane-en > .landlord,
.col-plane-en > .plane {
  width: 80px;
}
.plane{
  width: 60px;
  height: 18px;
  background: #E3F0FF;
  box-shadow: 0 0 0 1px #056DE0;
  border-radius: 2px;
  box-sizing: border-box;
  padding: 0 3px;
  font-size: 12px;
  color: #056DE0;
  line-height: 18px !important;
  margin-top: 8px;
  display: flex;
  align-items: center;
  height: 18px;
  margin-left: 1px;
}
.landlord{
  width: 60px;
  height: 18px;
  background: #FFE3E3;
  box-shadow: 0 0 0 1px #ed1c24;
  border-radius: 2px;
  box-sizing: border-box;
  padding: 0 3px;
  font-size: 12px;
  color: #ED1C24;
  line-height: 18px !important;
  display: flex;
  align-items: center;
  height: 18px;
  margin-top: 8px;
  margin-left: 1px;
}
.landlord > span,
.plane > span {
  transform: scale(0.95);
  transform-origin: 50% 100%;
}
.col-tag {
  margin-left: 5px;
  margin-top: 5px;
  height: 16px;
  padding: 1px 3px;
  color: #fff;
  text-align: center;
  background-color: #f2a018;
  border-radius: 2px;
  display: flex;
  -webkit-transform: scale(0.9);
  font-size: 10px;
  font-family: PingFangSC-Medium;
  line-height: 16px;
}
.imageNumber {
  position: absolute;
  top: 67px;
  left: 87px;
  width: 28px;
  height: 18px;
  background-color: rgba(0, 0, 0, 0.5);
  font-size: 12px;
  color: #fff;
  text-align: center;
  border-radius: 2px;
  line-height: 18px;
}
.card-tags {
  color: #4d73bf;
  font-size: 13px;
}
/* 标签部分 */
.info-property-tags{
  width: calc(100% - 136px);
  max-height: 125px;
  margin-left: 136px;
  padding-right: 15px;
  /* background-color: pink; */
  text-align: left;
  display: inline-block;
}
.tags-span{
  max-width: calc(100% - 15px);
  color: #617e9d;
  margin: 0px 4px 4px 0;
  padding: 0 4px;
  font-size: 12px;
  line-height: 16px;
  display: inline-block;
  background-color: #eef8ff;
  font-family: PingFangSC-Regular;
}
.property {
  color: #536ea6;
  background-color: #dfe9ff;
}
/* 价格部分 */
.van-card__bottom {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  line-height: 13px;
}
.bh-price{
  display: flex;
  align-items: center;
  margin-left: 136px;
  padding-right: 15px;
  padding-bottom: 9px;
}
.saleform{
  font-size: 10px;
  color: #333;
}
.card-price {
  font-size: 20px;
  font-weight: bold;
  color: #ed1c24;
}
.card-price-small{
  margin-top: 2px;
  font-size: 14px;
  color: #ed1c24;
}
.card-price-small-en{
  margin-top: 5px;
  font-size: 14px;
  color: #ed1c24;
}
.col-price {
  display:flex;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-direction: row;
  align-items: flex-start;
}
.practical {
  padding-left: 4px;
  font-size: 11px;
  color: #999999;
  max-width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.practical span{
  line-height: 14px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.build span{
  line-height: 14px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.build{
  padding-left: 4px;
  font-size: 11px;
  color: #999999;
  max-width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.practical-top .practical-bottom{
  display: block;
  color:red;
}
.bottom{
  display: flex;
}
.col-remark {
  display: inline-block;
  margin-top: 2px;
  height: 18px;
  font-size: 12px;
  color: #999999;
}
.msg-cell {
  border-bottom: 0px !important;
  padding: 15px 0px 6px 0 !important;
}
.centa-li .inco-xin {
  height: 18px;
  width: 18px;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAAAXNSR0IArs4c6QAAArJJREFUWAntl7uvEkEUxscXLmJ8oDG6aiwVS2NoJFZ29lY0thoSE0208lX4n9AQCmrIrRQo7k2kARMgUkAob9TAwq6Xxe+bzCSSu7rssmxi4klOzj7OnO+3s7Mzs0L8t8164EiA5kFyhV/ySQgn4YzHFMQS8QBuwy11jCCOw0/BmctjXXuB47lytvG0o55XhTiB6xfhF+AsLiEymQyvU4DxNPwS/Bz8vDrmNZmjcnEq26YQWYtOyLWMPXAFbhYKhdvj8fiDbdufXdedLWGLxeLbZDKpdjqdJ6ZpXmceHcI3er3eM8uydpDzg7loY83n873RaPQ+n8/fVLmsbcD/auxWWZhCuiCLehkAvxSLxfuVSuWB4zhfvXL0NdTab7Vaj3V9xMSfSNj9sieGw+FbXcAvQmCie8svF3nLfr//QsFcRvQcGmeZ0Gw2H6GB61c07H2UPqjVag8VzBnEFSOZmU6nr7G7w4qs2242m+1SD843IL8u3TUcG6JcLt9JJBK3eLxNMwzjbqlUog4hpLYG4ScnMPJzjHFYNpu9p3SktgaR80QymbwaBwQ1UqmU1pIMGkTq4x27cYFAZ0VLg3AaFhhEo7hAptOp1pJAGuQnAdrt9qe4QBqNRl1pOb9rEkjOqPh8W+t+hmHzsAx8VHqHPl92z5Rk9Xr9NQTkq+J51IbaTrVafafqThC5mq8Ye4XTrjkYDF6GfVq/dljDnlJDuR4aOF01LkQyCevNG7+iQe9jnXmu6yP6rsDcBkQOExQCDNIihQkLESnMphCRwEQFsRFM1BChYLYFEQhm2xBrwcQFcQgGM/Ar7EFtuNXtdgtI0DOm72Sli+ko94v6JEDkPMOfKpHL5Qz857j4VXBU+31E/tkFsrAgFOFywJ2/3OohEuQ7XG4pEGM3PswmDxQ78L8h+Avh2bk0oDKIsAAAAABJRU5ErkJggg==);
  background-size: 18px 18px;
  position: absolute;
  right: 3px;
  z-index: 9;
  top: 3px;
}
.bh-company{
  margin:5px 0 0 136px;
  font-size: 11px;
  color: #333333;
  height:20px;
  padding-right:15px;
}
</style>
